import { isValidDate } from "utils/date";

import { useProfileContext } from "./useProfileContext";

export const useIsPtOoo = () => {
  const { profile } = useProfileContext();
  let isPtOoo = false;

  if (profile && profile.active_time_off_period?.end_date) {
    const date = new Date(profile.active_time_off_period.end_date);

    if (isValidDate(date)) {
      isPtOoo = date > new Date();
    }
  }
  return {
    isPtOoo,
    isHyrbridPatientsExcluded: profile?.therapist_profile?.feature_flags?.includes("HYBRID_OOO_EXCLUDE"),
  };
};
